<script setup lang="ts">
import Avatar from 'primevue/avatar'
import Menu from 'primevue/menu'
import { ref } from 'vue'
import { ClientOnly } from '@vuepress/client';
import { useAuth0 } from '@auth0/auth0-vue';

// Initialize with defaults for SSR
let isAuthenticated = ref(false)
let user = ref(null)
let logout = null
let loginWithRedirect = null

// Only use Auth0 on client-side
if (!__VUEPRESS_SSR__ && !__VUEPRESS_DEV__) {
  const auth0 = useAuth0();
  isAuthenticated = ref(auth0.isAuthenticated);
  user = ref(auth0.user);
  logout = auth0.logout;
  loginWithRedirect = auth0.loginWithRedirect;
}

const menu = ref()

const items = ref([
  {
    label: 'Abmelden',
    command: () => {
      if (logout) {
        logout({ logoutParams: { returnTo: window.location.origin } });
      }
    }
  }
])

const toggle = (event: Event) => {
  menu.value.toggle(event)
}

function login() {
  if (loginWithRedirect) {
    loginWithRedirect()
  }
}
</script>

<template>
  <div class="profile-nav">
    <ClientOnly>
      <Avatar 
        v-if="isAuthenticated && user?.name" 
        @click="toggle"
        class="cursor-pointer"
        shape="circle"
      >
        {{ user.name.charAt(0).toUpperCase() }}
      </Avatar>
      <a href="" v-else @click.prevent="login" class="login-button">
        <i class="pi pi-sign-in"></i>
      </a>
      <Menu ref="menu" id="profile_menu" :model="items" :popup="true" />
    </ClientOnly>
  </div>
</template>

<style scoped>
.profile-nav {
  padding-left: 1rem;
  display: flex;
  align-items: center;
}

.profile-link {
  color: var(--c-text);
}

.login-button {
  display: flex;
  align-items: center;
  color: var(--c-text);
  font-size: 1.5rem;
}

.login-button:hover {
  opacity: 0.8;
}
</style>
